// Photos shown in the "Follow Along on Instagram" carousel, in display order.
//
// To update: save photos from @bobbiesuesmac into src/images/instagram/
// (square crops, about 640x640 JPEG, under ~100 KB each), import them below
// and add an entry. `url` links the tile to its Instagram post (leave it out
// to link to the profile). Write `alt` to describe what's in the photo. Add a
// `credit` when the photo came from another account.
import bbqChickenMac from "../images/instagram/bbq-chicken-mac.jpg";
import campMacCheesePull from "../images/instagram/camp-mac-cheese-pull.jpg";
import ossfestAtTheShack from "../images/instagram/ossfest-at-the-shack.jpg";
import carbonaraMacTasteToronto from "../images/instagram/carbonara-mac-taste-toronto.jpg";
import classicMacTakeout from "../images/instagram/classic-mac-takeout.jpg";
import campMacOverhead from "../images/instagram/camp-mac-overhead.jpg";
import carbonaraClassicPulledPork from "../images/instagram/carbonara-classic-pulled-pork.jpg";
import blogtoBestMacAndCheese from "../images/instagram/blogto-best-mac-and-cheese.jpg";

const instagramPhotos = [
  {
    image: bbqChickenMac,
    url: "https://www.instagram.com/p/DMF8Yj9MDIN/",
    alt: "BBQ Chicken Mac topped with pulled chicken and smoky BBQ sauce in a takeout box",
  },
  {
    image: campMacCheesePull,
    url: "https://www.instagram.com/p/DaoAqmBSaci/",
    alt: "Camp Mac with beef hot dog medallions and a long cheese pull on a fork",
  },
  {
    image: ossfestAtTheShack,
    url: "https://www.instagram.com/p/DbPKzCAMurp/",
    alt: "A crowd outside the Bobbie Sue's Mac + Cheese shack during Ossfest",
  },
  {
    image: carbonaraMacTasteToronto,
    url: "https://www.instagram.com/p/DQX4gHxDzGJ/",
    alt: "Carbonara Mac in a takeout tin with a cheesy forkful lifted out",
    credit: "Via @tastetoronto",
  },
  {
    image: classicMacTakeout,
    url: "https://www.instagram.com/p/CbQd2rHO5Es/",
    alt: "Baked mac and cheese with a golden top in a takeout box",
  },
  {
    image: campMacOverhead,
    url: "https://www.instagram.com/p/CqSxTrpOxPJ/",
    alt: "Camp Mac topped with beef hot dog medallions, seen from above",
    credit: "Photo: @abeefoods",
  },
  {
    image: carbonaraClassicPulledPork,
    url: "https://www.instagram.com/p/CZ2omFKL73Y/",
    alt: "Carbonara, Classic and Pulled Pork Macs in open takeout boxes",
    credit: "Photo: @mell.eats",
  },
  {
    image: blogtoBestMacAndCheese,
    url: "https://www.instagram.com/p/BneOLv_Aali/",
    alt: "blogTO's \"The Best Mac and Cheese in Toronto\" feature showing Bobbie Sue's mac and cheese",
    credit: "Via @blogto",
  },
];

export default instagramPhotos;
